<template>
  <div
    :style="'padding:'+(data.style.paddingTB*0.9)+'px '+(data.style.paddingLR*0.9) +'px;'"
    class="windows ">
    <div v-for="(item,index) in data.data" :key="index" :class="data.style.class">
      <img class="width100" :src="item.imgUrl?info.picdomain+item.imgUrl : require('@/assets/images/normal.png')" alt="">
    </div>
  </div>
</template>
<script>

  import { ref } from "vue";
  import store from "@/store";
  export default {
    props: { data: Object },
    name: "windows",
    setup() {
      return {
        info: ref(store.state.user.info)
      }
    }
  }
</script>

<style lang="less" scoped>
  .windows {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .full {
      width: 100%;
    }

    .half {
      width: 50%;
    }

    .third {
      width: 33%;
    }

    .quarter {
      width: 25%;
    }
  }
</style>